<template>
  <layout>
    <div class="container my-4">
      <div class="row">
        <div class="col-md-12">
          <b-card>
            <div
              v-if="!ready"
              class="d-flex flex-column align-items-center mt-4 mb-4"
            >
              <b-spinner
                style="width: 4rem; height: 4rem"
                variant="primary"
                label="Spinning"
              />
            </div>

            <div class="document-toolbar mb-4" v-if="ready">
              <div>
                <b-button
                  @click="$router.back()"
                  variant="link"
                  size="sm"
                  class="font-weight-bold"
                >
                  <i class="fa fa-arrow-left" />
                  Back
                </b-button>
              </div>

              <div>
                {{ formComputed.name }}
                Sent by {{ formComputed.current.createdBy.fullName }} On
                {{ formComputed.current.createdAt | formatDate }}
              </div>
            </div>

            <div
              class="d-flex w-100 h-100 pb-3"
              v-if="isActionRequired && ready"
            >
              <div
                class="sidebar-forms-container bg-extra-light-gray d-flex flex-column justify-content-between"
              >
                <div v-if="formGroup" class="sidebar-forms">
                  <div v-for="form in formGroup.forms" :key="form.id">
                    <div
                      @click="prevSetCurrentFormItem(form.id)"
                      class="sidebar-menu-form-item d-flex flex-row align-items-center justify-content-between rounded-right"
                      :class="
                        form.id == formId ? 'bg-primary' : 'hover-bg-light-blue'
                      "
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        style="width: 85%"
                      >
                        <span
                          class="ml-2 no-wrap-text"
                          :class="
                            getFormDocumentColor(form.id)
                              ? 'text-' +
                                getFormDocumentColor(form.id) +
                                (form.id == formId ? ' text-shadow' : '')
                              : form.id == formId
                              ? 'text-white'
                              : ''
                          "
                          :id="'form-group-tooltip-' + form.id"
                        >
                          {{ form.name }}
                        </span>
                      </div>
                      <i
                        v-if="getFormDocumentIcon(form.id)"
                        class="fa mr-3"
                        :class="'fa-' + getFormDocumentIcon(form.id)"
                      ></i>
                      <div
                        v-else-if="form.id == formId"
                        class="little-circle bg-white rounded-circle mr-3"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class=" text-center border-left current-form-container w-100 h-100"
                v-if="currentForm"
              >
                <div
                  class="d-flex flex-column justify-content-between align-items-center border-bottom px-3 bg-extra-light-gray p-2"
                >
                  <div
                    class="w-100 d-flex flex-row justify-content-between align-items-center"
                  >
                    <h5 class="modal-title font-weight-bold" align="center">
                      {{ modalTitle }}
                    </h5>
                    <!-- <div class="modal-subtitle">{{ modalSubtitle }}</div> -->
                  </div>
                </div>

                <div class="builder w-100 p-2 position-relative">
                  <div class="position-relative">
                    <div
                      class="disable-form bg-med-light-gray"
                      v-if="document && document.status == 'Completed'"
                    ></div>
                    <fb-form-viewer
                      :json="currentForm.version.content.layout"
                      showType="form-submitter"
                      ref="formViewer"
                    ></fb-form-viewer>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center p-2 border-top bg-extra-light-gray"
                >
                  <!-- <div
                    class="d-flex align-items-center mr-2 color-custom-dark-grey mt-1"
                    v-if="document && document.lastUpdated"
                  >
                    <i class="fa fa-save mr-2 text-primary"></i>
                    <span style="font-size: 12px">
                      Last saved: {{ formatDate(document.lastUpdated) }}
                      <span class="text-primary">
                        ({{ formatTimeAgo(document.lastUpdated) }})
                      </span>
                    </span>
                  </div> -->

                  <div class="text-danger text-left">
                    {{ validationErrorMessage }}
                  </div>

                  <div class="mt-1">
                    <b-button
                      class="mr-2"
                      variant="primary"
                      size="sm"
                      @click="prevSubmitForm(null)"
                    >
                      Complete and Submit
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <b-row
              v-if="!isActionRequired && ready"
              v-html-sanitize="documentRendered"
              class="document-render-container"
            >
              Hello
              <!-- This Document is complete and submitted. -->
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import documentServer from "../../server/document";
import Layout from "../workspace/Layout.vue";
import serverCatalog from "../../server/catalog";
import serverEoc from "../../server/eoc";
import {
  formatDateOnlyMysql,
  formatDateTimeSql,
  formatDatePretty,
  formatDateTimeMysql
} from "../../helpers/date";
import { hasClass } from "../../helpers/layout";
import { validateRequired, validateDateTime } from "../../helpers/validation";
import documentGroup from "../../server/documentGroup";
import scheduleEventServer from "../../server/scheduleEvents";
import scheduledMedicationServer from "../../server/scheduledMedication";
const getFormSubmitId = (results, formId) => {
  for (let index = 0; index < results.length; index++) {
    const result = results[index];
    if (result.formId == formId) return result.documentId;
  }
  return null;
};

export default {
  name: "DocumentGroupAddEditModal",
  components: {
    Layout
  },
  data() {
    return {
      ready: false,
      sharedDocumentId: this.$route.params.sharedDocumentId,
      sharedDocument: {},
      documentRendered: "",
      eocId: "",
      submitId: null,
      formGroup: null,
      submit: null,
      formId: "",
      document: null,
      validationErrorMessage: "",
      effectiveDateTime: null,
      effectiveDateTimeErrors: [],
      refetchDocuments: false,
      initialEffectiveDate: null,
      initialEffectiveTime: null,
      client: {},
      documentStatus: "Pending",
      eoc: null
    };
  },
  async mounted() {
    // const currentAdjustedDateTime = this.getCurrentAdjustedDateTime();
    const currentAdjustedDateTime = new Date();
    this.effectiveDateTime = formatDateTimeMysql(currentAdjustedDateTime);
    this.initialEffectiveDate = formatDateOnlyMysql(currentAdjustedDateTime);
    this.initialEffectiveTime = moment(currentAdjustedDateTime).format("HH:mm");

    this.setCurrentForm(null);
    this.sharedDocument = await documentServer.getSharedDocument(
      this.sharedDocumentId
    );
    await this.renderDocuments();
    this.submitId = this.sharedDocument.documentGroup?.id;
    this.formGroup = await this.getFormGroupById(
      this.sharedDocument.formGroup.id
    );
    if (this.submitId) {
      this.submit = await this.getFormGroupSubmitById(this.submitId);
    }
    await this.initializeFormGroupSubmit({
      submitId: this.submitId,
      formGroupId: this.formGroup.id,
      clientId: this.user.PatientId,
      results: this.submit ? this.submit.results : null,
      formIds: this.formGroup.formIds,
      eocId: this.sharedDocument.episodeOfCareId
    });
    const form = await this.getFormBuilderFormById(this.formGroup.formIds[0]);
    const version = await this.getFormBuilderFormVersionById(form.current.id);

    let documentId = null;
    if (this.submit) {
      documentId = getFormSubmitId(this.submit.results, form.id);
    }
    await this.initializeFormSubmit(form.id, documentId);
    this.setCurrentForm({ form, version });
    this.ready = true;
  },
  methods: {
    ...mapMutations("formGroupSubmitter", [
      "initializeFormGroupSubmit",
      "setCurrentForm"
    ]),
    ...mapMutations("formSubmitter", [
      "setInitialValues",
      "setFormSubmitterFormHasUnsavedChanges"
    ]),
    ...mapActions("formGroupSubmitter", ["addFormGroupSubmit"]),
    ...mapActions("formSubmitter", [
      "initializeFormSubmitterForm",
      "addFormSubmitterForm",
      "editFormSubmitterForm",
      "validateFormSubmitterForm"
    ]),
    ...mapActions("session", ["loadDocuments"]),
    async initializeFormSubmit(formId, submitId) {
      this.formId = formId;
      await this.setInitialValues();
      let submit = null;
      let form = await this.getFormBuilderFormById(formId);
      let version = form.current;
      if (submitId) {
        submit = await this.getFormSubmitById(submitId);
        version = await this.getFormBuilderFormVersionById(submit.versionId);
      }
      this.document = submit;
      this.documentStatus = submit ? submit.status : "Pending";
      const client = await serverCatalog.getClient(this.user.PatientId);
      const eoc = await serverEoc.get(this.sharedDocument.episodeOfCareId);
      this.eoc = eoc;

      const eocCares = await scheduleEventServer.query({
        episodeOfCareIds: [eoc.id],
        types: ["LOC"]
      });
      const primaryProvider = eoc.caseLoads.find(
        cL => cL.caseRole.type == "PrimaryProvider"
      )
        ? eoc.caseLoads.find(cL => cL.caseRole.type == "PrimaryProvider").user
        : null;
      const medicationScheduledList = await scheduledMedicationServer.query(
        eoc.id
      );
      const clientFiltered = {
        id: client.id,
        mrn: client.mrn,
        firstName: client.firstName,
        middleName: client.middleName,
        lastName: client.lastName,
        dateOfBirth: client.dateOfBirth,
        email: client.email,
        phone: client.phone,
        ssn: client.ssn,
        ssnUnmasked: client.ssnUnmasked,
        gender: client.gender ? client.gender.name : "",
        race: client.race ? client.race.name : "",
        ethnicity: client.ethnicity ? client.ethnicity.name : "",
        language: client.language ? client.language.name : "",
        city: client.city,
        state: client.state ? client.state.name : "",
        maritalStatus: client.maritalStatus ? client.maritalStatus.name : "",
        occupation: client.occupation,
        zipcode: client.zipcode,
        addressLine1: client.addressLine1,
        addressLine2: client.addressLine2,
        episodeOfCare: {
          id: eoc.id,
          eocn: eoc.eocn,
          status: eoc.status,
          location: eoc.location ? eoc.location.name : "",
          startDate: eoc.startDate,
          endDate: eoc.endDate,
          additionalsReportResults: eoc.additionalsReportResults,
          referralSource: eoc.referralSource,
          primaryProvider: primaryProvider
            ? {
                id: primaryProvider.id,
                firstName: primaryProvider.firstName,
                lastName: primaryProvider.lastName,
                middleName: primaryProvider.middleName,
                credentials: primaryProvider.credentials
              }
            : null,
          eocCares: eocCares.map(eocC => ({
            day: formatDateOnlyMysql(eocC.startDateTime),
            levelOfCare:
              eocC.services.length > 0 ? eocC.services[0].service.name : ""
          })),
          medicationScheduledList: medicationScheduledList
        },
        insurances: client.insurances,
        allergies: client.allergies,
        contacts: client.contacts,
        guarantors: client.guarantors
      };
      await this.initializeFormSubmitterForm({
        formId: formId,
        formName: form.name,
        version: version,
        client: clientFiltered,
        eoc: eoc,
        document: submit ? submit : null,
        showType: "form-submitter"
      });
      this.client = clientFiltered;
      this.effectiveDate = submit
        ? moment(submit.effectiveDate).format("YYYY-MM-DD")
        : this.initialEffectiveDate;
      this.effectiveTime = submit
        ? moment(submit.effectiveDate).format("HH:mm")
        : this.initialEffectiveTime;
    },
    async validateFormSubmit() {
      let withoutErrors = await this.validateFormSubmitterForm();

      this.effectiveDateTimeErrors = [];
      if (!validateRequired(this.effectiveDateTime)) {
        this.effectiveDateTimeErrors.push("This field is required");
        withoutErrors = false;
      }

      if (this.effectiveDateTime && !validateDateTime(this.effectiveDateTime)) {
        this.effectiveDateTimeErrors.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    prevSubmitForm(callbackConfirm = null) {
      if (
        this.document &&
        this.document.status == "Completed" &&
        this.documentStatus != this.document.status
      ) {
        this.$dialog
          .confirm(
            {
              title:
                'This will set the document status to "PENDING" do you want to continue?'
            },
            {
              view: "confirm"
            }
          )
          .then(async () => {
            this.submitForm(callbackConfirm);
          })
          .catch(function() {});
      } else {
        this.submitForm(callbackConfirm);
      }
    },
    async submitForm(callbackConfirm) {
      this.validationErrorMessage = "";
      let result = true;
      if (this.documentStatus != "Draft") {
        result = await this.validateFormSubmit();
      }

      if (result) {
        const bakedLayout = this.$refs.formViewer.getBakedLayout();
        if (!this.submitId) {
          const submit = await this.addFormGroupSubmit({ mode: "Results" });
          this.submitId = submit.id;
        }
        if (
          this.submit &&
          getFormSubmitId(this.submit.results, this.currentForm.form.id)
        ) {
          await this.editFormSubmitterForm({
            submitId: this.sharedDocumentId,
            mode: "Results",
            status: this.documentStatus,
            effectiveDate: formatDateTimeSql(this.effectiveDateTime),
            documentGroupId: this.submitId,
            bakedLayout
          });
        } else {
          await this.addFormSubmitterForm({
            sharedDocumentId: this.sharedDocument.id,
            documentGroupId: this.submitId,
            status: this.documentStatus,
            effectiveDate: formatDateTimeSql(this.effectiveDateTime),
            bakedLayout
          });
          this.initialEffectiveDate = this.effectiveDate;
          this.initialEffectiveTime = this.effectiveTime;
        }
        this.refetchDocuments = true;
        if (callbackConfirm) {
          callbackConfirm();
          return;
        }
        let formIndex = this.formIds.indexOf(this.currentForm.form.id);
        this.setCurrentForm(null);
        if (formIndex >= this.formIds.length - 1) formIndex = -1;
        const form = await this.getFormBuilderFormById(
          this.formGroup.formIds[formIndex + 1]
        );
        const version = await this.getFormBuilderFormVersionById(
          form.current.id
        );

        let documentId = null;
        if (this.submit) {
          documentId = getFormSubmitId(this.submit.results, form.id);
        }
        this.submit = await this.getFormGroupSubmitById(this.submitId);
        await this.initializeFormSubmit(form.id, documentId);
        this.setCurrentForm({ form, version });
      } else {
        let firstErrorElement = document.querySelector(".is-invalid");
        let topPos = 0;
        while (!hasClass(firstErrorElement, "builder")) {
          topPos += firstErrorElement.offsetTop;
          firstErrorElement = firstErrorElement.offsetParent;
        }
        document.querySelector(".form-group-submit-modal .builder").scrollTop =
          topPos - 10;
        this.validationErrorMessage = "Please fix errors and try again.";
      }
      this.ready = false;
      this.loadDocuments();
      this.sharedDocument = await documentServer.getSharedDocument(
        this.sharedDocumentId
      );
      await this.renderDocuments();
      this.ready = true;
    },
    prevSetCurrentFormItem(formId) {
      if (this.hasUnsavedChanges) {
        this.$dialog
          .confirm(
            {
              title: "Do you want to save your changes?"
            },
            {
              view: "confirm-unsaved-changes"
            }
          )
          .then(async ({ data }) => {
            if (data.confirmValue) {
              this.prevSubmitForm(async () => {
                this.submit = await this.getFormGroupSubmitById(this.submitId);
                this.setCurrentFormItem(formId);
              });
            } else {
              this.setCurrentFormItem(formId);
            }
          })
          .catch(function() {});
      } else {
        this.setCurrentFormItem(formId);
      }
    },
    async setCurrentFormItem(formId) {
      this.setCurrentForm(null);
      const form = await this.getFormBuilderFormById(formId);
      const version = await this.getFormBuilderFormVersionById(form.current.id);

      let documentId = null;
      if (this.submit) {
        documentId = getFormSubmitId(this.submit.results, form.id);
      }
      await this.initializeFormSubmit(form.id, documentId);
      this.setCurrentForm({ form, version });
    },
    getFormDocumentColor(formId) {
      if (this.submit) {
        for (let index = 0; index < this.submit.results.length; index++) {
          const result = this.submit.results[index];
          if (result.formId == formId) {
            if (result.status == "Completed") return "success";
            if (result.status == "Draft") return "danger";
            return "warning";
          }
        }
      }
      return "";
    },
    getFormDocumentIcon(formId) {
      if (this.submit) {
        for (let index = 0; index < this.submit.results.length; index++) {
          const result = this.submit.results[index];
          if (result.formId == formId) {
            if (result.status == "Completed") return "check text-success";
            if (result.status == "Draft") return "clock-o text-danger";
            return "clock-o text-warning";
          }
        }
      }
      return "";
    },
    formatDatePretty(dateTime) {
      return formatDatePretty(dateTime);
    },
    async renderDocuments() {
      if (this.sharedDocument.documentGroup?.id) {
        documentGroup
          .render(this.sharedDocument.documentGroup.id)
          .then(res => {
            this.documentRendered = res.data;
          })
          .catch(console.error);
      }
    }
  },
  computed: {
    ...mapState("formGroupSubmitter", {
      currentForm: state => state.currentForm,
      formIds: state => state.formGroupSubmit.formIds
    }),
    ...mapState("formSubmitter", {
      hasUnsavedChanges: state => state.form.hasUnsavedChanges
    }),
    ...mapGetters("formSubmitter", ["getFormSubmitById"]),
    ...mapGetters("formGroupSubmitter", ["getFormGroupSubmitById"]),
    ...mapGetters("formGroup", ["getFormGroupById"]),
    ...mapGetters("formBuilder", [
      "getFormBuilderFormById",
      "getFormBuilderFormVersionById"
    ]),
    ...mapGetters("session", ["user"]),
    // ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    // ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    modalSize() {
      return this.currentForm &&
        this.currentForm.version.content.properties.modalSize
        ? this.currentForm.version.content.properties.modalSize
        : "lg";
    },
    modalTitle() {
      let title = this.formGroup ? this.formGroup.name : "";
      return title;
    },
    modalSubtitle() {
      let title = "";
      if (this.eoc) {
        title = this.formatEoc(
          " | " + this.eoc.patient.firstName,
          this.eoc.patient.lastName,
          this.eoc.patient.mrn,
          this.eoc.eocn
        );
      }
      return title;
    },
    statusClass() {
      if (this.documentStatus) {
        switch (this.documentStatus) {
          case "Pending":
            return "badge-warning text-white";
          case "Completed":
            return "badge-success text-white";
          case "Draft":
            return "badge-danger";
          default:
            break;
        }
      }
      return "light";
    },
    statusIcon() {
      if (this.documentStatus) {
        switch (this.documentStatus) {
          case "Pending":
            return "fa-clock";
          case "Completed":
            return "fa-check-circle";
          case "Draft":
            return "fa-clock";
          default:
            break;
        }
      }
      return "light";
    },
    formComputed() {
      return {
        ...this.sharedDocument,
        name: this.sharedDocument.formGroup?.name || "Untitled",
        current: {
          createdAt: this.sharedDocument.sentAt || "",
          createdBy: {
            firstName: this.sharedDocument.sentBy?.firstName || "N/A",
            lastName: this.sharedDocument.sentBy?.lastName || "N/A",
            fullName: this.sharedDocument.sentBy?.fullName || "N/A"
          }
        }
      };
    },
    isActionRequired() {
      return !this.sharedDocument.readOnly;
    }
  },
  watch: {
    effectiveDateTime() {
      this.setFormSubmitterFormHasUnsavedChanges({ hasUnsavedChanges: true });
    }
  }
};
</script>

<style scoped>
.sidebar-menu-form-item {
  margin-top: 5px;
  padding-left: 20px;
  height: 44px;
  width: 96%;
  font-size: 16px;
}
.little-circle {
  width: 10px;
  height: 10px;
}
.sidebar-menu-form-item:hover {
  cursor: pointer;
}
.builder {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 89px);
}
.sidebar-forms-container {
  width: 300px;
  margin-left: -16px;
  margin-top: -16px;
  margin-bottom: -30px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% + 32px);
  z-index: 2;
}
.current-form-container {
  margin-top: -16px;
  margin-right: -16px;
  margin-bottom: -30px;
}
.no-wrap-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.disable-form {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  opacity: 0.3;
}
.effective-date-container {
  height: 70px;
  max-height: 70px;
}
.form-title-container {
  max-width: calc(100% - 595px);
}
.text-shadow {
  text-shadow: 2px 2px 4px #000000;
}
.modal-subtitle {
  font-size: 14px;
  margin-top: -4px;
}
.status-badge {
  font-size: 16px;
  padding: 10px 18px !important;
}
</style>

<style>
.effective-date-container .input-group-prepend,
.input-group-append {
  display: initial;
}
.shadow-form {
  box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.5);
}
</style>

<style scoped>
.document-render-container >>> .general-container {
  background: transparent !important;
}
.document-render-container >>> .general-container .document-view {
  padding: 0;
  margin: 0 15px;
  max-width: 100% !important;
}
</style>
